export function getRemainingTimeSinceClaim(claimedAt) {
  if (!claimedAt) return null;

  const claimedDate = new Date(claimedAt);
  const targetDate = new Date(claimedDate.getTime() + 24 * 60 * 60 * 1000); // +24h
  const now = new Date();
  const diff = targetDate - now;

  if (diff <= 0) {
    return { expired: true, hours: 0, minutes: 0, seconds: 0 };
  }

  const hours = Math.floor(diff / (1000 * 60 * 60));
  const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((diff % (1000 * 60)) / 1000);

  return { expired: false, hours, minutes, seconds };
}
